import { useWallets } from '@/hooks/useWallets'
import { useLogin, useLogout, usePrivy, WalletWithMetadata } from '@privy-io/react-auth'
import { useRouter } from 'next/router'
import { useCallback } from 'react'
import { Address } from 'viem'

export function useWalletAuth() {
  const { add, wallets, remove } = useWallets()
  const { ready, authenticated } = usePrivy()
  const router = useRouter()

  const { login } = useLogin({
    onComplete: ({ user, wasAlreadyAuthenticated, loginMethod }) => {
      if (wasAlreadyAuthenticated) return

      if (loginMethod === 'siwe') {
        const externalWallet = user.linkedAccounts.find(
          (account) => account.type === 'wallet' && account.walletClientType !== 'privy'
        ) as WalletWithMetadata
        add([
          {
            address: externalWallet.address as Address,
            walletClientType: externalWallet.walletClientType,
          },
        ])
      } else {
        add([
          {
            address: user.wallet?.address as Address,
            walletClientType: user.wallet?.walletClientType,
          },
        ])
      }

      router.push('/claim')
    },
  })

  const { logout } = useLogout({
    onSuccess: () => {
      wallets.forEach(([address]) => {
        remove(address)
      })

      router.push('/')
    },
  })

  const handleAuthenticate = useCallback(async () => {
    if (authenticated) await logout()
    login()
  }, [authenticated, logout, login])

  return {
    ready,
    authenticated,
    hasConnectedWallet: wallets.length > 0,
    login: handleAuthenticate,
    logout,
  }
}
